import { Button, Card, Col, Form, Row, Select, Spin, Table, message } from 'antd';
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import { CSVLink } from "react-csv";
import jsPDF from 'jspdf';
// Emoji and characters Helvetica can't print (asset names, locations) -> util/pdfText.js
import { createPdfTextTracker, unprintableNote, unprintableToast } from '../../util/pdfText';

import './style.css';

const { Column } = Table;

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.headerCompare = this.headerCompare.bind(this);
    this.assetTypeCompare = this.assetTypeCompare.bind(this);
    this.state = {
      clientFilterType: '',
      locationFilterType: '',
      assetTypeFilterType: '',
      assetSubTypeFilterType: '',
      ownerFilterType: '',
      downloadActive: false,
    };
  }

  componentDidMount() {
    const { match, fetch, assetTypes } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    if (!assetTypes)
      this.props.getAllAssetType();
  }

  componentWillReceiveProps(nextProps, nextContext) {

  }


  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = {};
      const { form: { getFieldValue }, filters, equipmentSubTypes, assetTypes } = this.props;
      const { clientFilterType, locationFilterType, assetTypeFilterType, assetSubTypeFilterType, ownerFilterType } = this.state;

      if (assetTypeFilterType === 'All') {
        // data.assetType = assetTypes.map(item => item._id);
      } else {
        // data.assetType = values.assetType;
      }

      if (clientFilterType === 'All') {
        data.client = filters['client'] && filters['client']['data'] && filters['client']['data']['data'].map(item => item._id);
        data.clientType = 'All';
      } else if (clientFilterType === 'Idle') {
        data.client = 'IDLE';
      } else if (clientFilterType === 'Off') {
        // data.client = 'OFF';
      } else if (clientFilterType === 'Idle-Off') {
        data.client = 'IDLE-OFF';
      } else {
        data.client = values.client;
      }

      if (locationFilterType === 'All') {
        data.location = filters['location'] && filters['location']['data'] && filters['location']['data']['data'].map(item => item._id);
        const soldLocation = (filters['location'] && filters['location']['data'] && filters['location']['data']['data']).filter(item => {
          if (item.name === "SOLD" || item.name === "Sold" || item.name === "sold") {
            return item
          }
        })

        if (soldLocation.length > 0) {
          data.location = data.location.filter(item => item !== soldLocation[0]._id);
        }
        data.location.push(null);
      } else if (locationFilterType === 'INTRANSIT') {
        data.location = null;
        data.client = null;
      } else {
        data.location = values.location;
      }

      if (assetSubTypeFilterType === 'All') {
        data.assetSubType = equipmentSubTypes.map(item => item._id);
      } else if (assetSubTypeFilterType === 'Off') {
        if (assetTypeFilterType !== 'All') {
          data.assetSubTypeType = 'Off';
          data.assetSubType = equipmentSubTypes.map(item => item._id);
        }
      } else {
        data.assetSubType = values.assetSubType;
      }

      if (ownerFilterType === 'All') {
        data.owner = filters['owner'] && filters['owner']['data'] && filters['owner']['data']['data'].map(item => item._id);
      } else {
        data.owner = values.owner;
      }

      this.props.fetchAssetReportData(data);
      this.setState({ downloadActive: true });
    });
  };

  handleAssetTypesChange = (e) => {
    if (e.length === 1) {
      if (e[0] === 'All') {
        this.props.getEquipmentSubTypeByAssetTypes('All');
      } else {
        this.props.getEquipmentSubTypeByAssetTypes(e);
      }
    } else {
      this.props.getEquipmentSubTypeByAssetTypes(e);
    }
  };

  handleSelect = (type, value) => {
    switch (type) {
      case 'client':
        this.setState({
          clientFilterType: value,
        });
        break;
      case 'location':
        this.setState({
          locationFilterType: value,
          clientFilterType: 'Off',
        });
        if (value === 'INTRANSIT') {
          this.props.form.setFieldsValue({
            'client': ['Off'],
          })
        }
        break;
      case 'assetType':
        this.setState({
          assetTypeFilterType: value
        });
        break;
      case 'assetSubType':
        this.setState({
          assetSubTypeFilterType: value
        });
        break;
      case 'owner':
        this.setState({
          ownerFilterType: value,
        });
        break;
      default:

    }
  };

  headerCompare = (a, b) => {
    if (a.dataIndex.toLowerCase() > b.dataIndex.toLowerCase()) {
      if (a.dataIndex.split('-')[0].toLowerCase() === b.dataIndex.split('-')[0].toLowerCase()) {
        if (b.dataIndex.includes('Total')) return -1;
      }
      return 1;
    }
    if (a.dataIndex.toLowerCase() < b.dataIndex.toLowerCase()) {
      if (a.dataIndex.split('-')[0].toLowerCase() === b.dataIndex.split('-')[0].toLowerCase()) {
        if (a.dataIndex.includes('Total')) return 1;
      }
      return -1;
    }
    return 0;
  };

  assetTypeCompare = (a, b) => {
    if (a.assetType.toLowerCase() > b.assetType.toLowerCase()) {
      return 1;
    }
    if (a.assetType.toLowerCase() < b.assetType.toLowerCase()) {
      return -1;
    }
    return 0;
  };

  downloadPdf = (headers, data) => {
    const marginLeft = 20;
    const doc = new jsPDF({
      format: [4000, 10000],
    });

    // Every table cell is cleaned and counted (see util/pdfText.js).
    const pdf = createPdfTextTracker();

    doc.setFontSize(2);

    const title = "AssetPro Asset Report";

    let content = {
      columns: headers,
      body: data,
      didParseCell: pdf.cellHook()
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    const unprintable = pdf.count();
    if (unprintable > 0) {
      doc.setFontSize(10);
      doc.text(unprintableNote(unprintable), marginLeft, doc.lastAutoTable.finalY + 10);
    }
    doc.save("report.pdf")
    if (unprintable > 0) message.warning(unprintableToast(unprintable), 8);
  };

  hideDownloadButton = () => {
    this.setState({ downloadActive: false })
  };


  render() {
    const { loading, title, resource, form, filters, assetTypes, equipmentSubTypes, reports } = this.props;
    const { clientFilterType, locationFilterType, assetTypeFilterType, assetSubTypeFilterType, ownerFilterType, downloadActive } = this.state;

    // data show on filter (assetTypes and equipmentSubTypes)
    const locationFilterData = filters['location'] && filters['location']['data'] && filters['location']['data']['data'];
    const clientFilterData = filters['client'] && filters['client']['data'] && filters['client']['data']['data'];
    const ownerFilterData = filters['owner'] && filters['owner']['data'] && filters['owner']['data']['data'];


    // get form fields
    const { getFieldDecorator } = form;
    const locationType = form.getFieldValue('location');
    const clientType = form.getFieldValue('client');
    const assetType = form.getFieldValue('assetType');
    const assetSubType = form.getFieldValue('assetSubType');
    const ownerType = form.getFieldValue('owner');

    // Creating column
    const columns = [
      {
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
      }
    ];
    if (assetSubType && assetSubType.length && (assetSubType.findIndex(item => item === 'Off') >= 0)) {
      columns.push({
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
        className: 'color-column',
      });
    } else {
      columns.push({
        title: 'Asset Sub Type',
        dataIndex: 'equipmentSubType',
        key: 'equipmentSubType',
      });
      columns.push({
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
        className: 'color-column',
      })
    }

    let dynamicColumns = [];
    const columnSet = [];

    // dynamic column creation
    reports && reports.map((item, index) => {
      const totalField = {
        title: `${item.location || 'Intransit'}-Total`,
        dataIndex: `${item.location}-Total`,
        key: `${item.location}-Total`,
        className: 'color-column',
      };

      if (clientFilterType !== 'Off' && item.location) {
        const col = {
          title: item.clientLocation,
          dataIndex: item.clientLocation,
          key: item.clientLocation,
        };
        columnSet.push(col);
      }
      columnSet.push(totalField);
    });

    // column sorting
    const dataJson = columnSet.map(JSON.stringify);
    const newArr = Array.from(new Set(dataJson)).map(JSON.parse);
    newArr.sort(this.headerCompare);

    // final column column
    dynamicColumns = [...columns, ...newArr];

    // data creation for table
    let dataSource = [];
    let assetsTotalData = {
      assetType: "-",
      equipmentSubType: 'Total',
      equipmentSubTypeId: 'assetsTotal',
      key: 'assetTotal',
      total: 0,
    };

    // data creating
    reports && reports.map((item, index) => {
      const equipmentSubTypeIndex = dataSource.findIndex(x => {
        if (x.equipmentSubTypeId) {
          return x.equipmentSubTypeId === item.equipmentSubTypeId;
        } else {
          return x.assetTypeId === item.assetTypeId;
        }
      });
      if (equipmentSubTypeIndex < 0) {
        if (item.equipmentSubTypeId) {
          const obj = {
            [item.clientLocation]: item.count,
            [`${item.location}-Total`]: item.count,
            assetType: item.assetType,
            equipmentSubType: item.equipmentSubType,
            equipmentSubTypeId: item.equipmentSubTypeId,
            total: item.count,
            key: index,
          };
          dataSource.push(obj);
        } else {
          const obj = {
            [item.clientLocation]: item.count,
            [`${item.location}-Total`]: item.count,
            assetType: item.assetType,
            assetTypeId: item.assetTypeId,
            total: item.count,
            key: index,
          };
          dataSource.push(obj);
        }
      } else {
        dataSource[equipmentSubTypeIndex][item.clientLocation] = item.count;
        dataSource[equipmentSubTypeIndex]['total'] += item.count;
        if (dataSource[equipmentSubTypeIndex][`${item.location}-Total`] === undefined) {
          dataSource[equipmentSubTypeIndex][`${item.location}-Total`] = item.count;
        } else {
          dataSource[equipmentSubTypeIndex][`${item.location}-Total`] += item.count;
        }
      }

      // Creating total count field
      assetsTotalData[item.clientLocation] !== undefined ? assetsTotalData[item.clientLocation] += (item.count || 0) : assetsTotalData[item.clientLocation] = (item.count || 0);
      assetsTotalData[`${item.location}-Total`] !== undefined ? assetsTotalData[`${item.location}-Total`] += (item.count || 0) : assetsTotalData[`${item.location}-Total`] = (item.count || 0);
      assetsTotalData['total'] += item.count;

    });

    // data sorted on the basis of assetType
    const dataSourceJson = dataSource.map(JSON.stringify);
    const data = Array.from(new Set(dataSourceJson)).map(JSON.parse);
    data.sort(this.assetTypeCompare);

    // making zero to for no assets available
    data && data.map((item, index) => {
      newArr.map(k => {
        if (!item[k.dataIndex]) {
          data[index][k.dataIndex] = 0;
        }
      })
    });
    data.push(assetsTotalData);
    const headers = dynamicColumns.map(item => {
      return {
        label: item.title,
        key: item.dataIndex,
      }
    });

    const cols = dynamicColumns.map(item => {
      return {
        header: item.title,
        dataKey: item.dataIndex,
      }
    });
    const titleForChangeName = `${sanitizeFieldName(resource)} ${title}`;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}
          title={titleForChangeName === 'Asset REPORT' ? 'Asset Availability Report' : `${sanitizeFieldName(resource)} ${title}`}>
          {/*<Card className={`gx-card-metrics`} title={`${sanitizeFieldName(resource)} ${title}`}>*/}
          <Form onSubmit={this.handleSubmit} className="ant-advanced-search-form" layout="inline" labelAlign="left">
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                {/* Location */}
                <Form.Item key={'location'} label={'Select Location'} style={{ width: '100%' }}>
                  {getFieldDecorator(`location`, {
                    rules: [{ required: true, message: `Location is required!` }],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Location`}
                  >
                    <Select.Option key={'AllLocation'}
                      disabled={locationFilterType !== 'All' && locationType && locationType.length > 0}
                      onClick={this.handleSelect.bind(this, 'location', 'All')}
                      value={'All'}>All</Select.Option>
                    <Select.Option key={'intransit'}
                      disabled={locationFilterType !== 'INTRANSIT' && locationType && locationType.length > 0}
                      onClick={this.handleSelect.bind(this, 'location', 'INTRANSIT')}
                      value={'INTRANSIT'}>Intransit</Select.Option>
                    {(locationFilterData || []).map(item =>
                      <Select.Option key={item._id}
                        onClick={this.handleSelect.bind(this, 'location', '')}
                        disabled={locationType && locationType.findIndex(item => item === 'All' || item === 'INTRANSIT') >= 0}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                {/* Client */}
                <Form.Item key={'client'} label={'Select Sub Location'} style={{ width: '100%' }}>
                  {getFieldDecorator(`client`, {
                    rules: [{ required: true, message: `Sub Location is required!` }],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    disabled={locationFilterType === 'INTRANSIT'}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Sub Location`}
                  >
                    <Select.Option key={'AllClient'}
                      onClick={this.handleSelect.bind(this, 'client', 'All')}
                      disabled={clientFilterType !== 'All' && clientType && clientType.length > 0}
                      value={'All'}>All</Select.Option>
                    <Select.Option key={'IdleClient'}
                      onClick={this.handleSelect.bind(this, 'client', 'Idle')}
                      disabled={clientFilterType !== 'Idle' && clientType && clientType.length > 0}
                      value={'Idle'}>Idle</Select.Option>
                    <Select.Option key={'Off'}
                      onClick={this.handleSelect.bind(this, 'client', 'Off')}
                      disabled={clientFilterType !== 'Off' && clientType && clientType.length > 0}
                      value={'Off'}>Off</Select.Option>
                    <Select.Option key={'idle-Off'}
                      onClick={this.handleSelect.bind(this, 'client', 'Idle-Off')}
                      disabled={clientFilterType !== 'Idle-Off' && clientType && clientType.length > 0}
                      value={'Idle-Off'}>Idle Off</Select.Option>
                    {(clientFilterData || []).map(item =>
                      <Select.Option key={item._id}
                        onClick={this.handleSelect.bind(this, 'client', '')}
                        disabled={clientType && clientType.findIndex(item => (item === 'All' || item === 'Idle'
                          || item === 'Off' || item === 'Idle-Off')) >= 0}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                {/* Asset Type */}
                <Form.Item key={'assetType'} label={'Select Asset Types'} style={{ width: '100%' }}>
                  {getFieldDecorator(`assetType`, {
                    rules: [{ required: true, message: `Asset types is required!` }],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    onChange={this.handleAssetTypesChange}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Asset Type`}
                  >
                    <Select.Option key={'AllAssetType'}
                      onClick={this.handleSelect.bind(this, 'assetType', 'All')}
                      disabled={assetTypeFilterType !== 'All' && assetType && assetType.length > 0}
                      value={'All'}>All</Select.Option>
                    {(assetTypes || []).map(item =>
                      <Select.Option key={item._id}
                        onClick={this.handleSelect.bind(this, 'assetType', '')}
                        disabled={assetType && assetType.findIndex(item => item === 'All') >= 0}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5} style={{ display: 'block' }}>
                {/* Asset Sub Type */}
                <Form.Item key={'Asset Sub Type'} label={'Select Asset Sub Type'} style={{ width: '100%' }}>
                  {getFieldDecorator(`assetSubType`, {
                    rules: [{ required: true, message: `Asset Sub Type is required!` }],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Asset Sub Type`}
                  >
                    <Select.Option key={'AllAssetSubType'}
                      onClick={this.handleSelect.bind(this, 'assetSubType', 'All')}
                      disabled={assetSubTypeFilterType !== 'All' && assetSubType && assetSubType.length > 0}
                      value={'All'}>All</Select.Option>
                    <Select.Option key={'Off'}
                      onClick={this.handleSelect.bind(this, 'assetSubType', 'Off')}
                      disabled={assetSubTypeFilterType !== 'Off' && assetSubType && assetSubType.length > 0}
                      value={'Off'}>Off</Select.Option>
                    {(equipmentSubTypes || []).map(item =>
                      <Select.Option key={item._id}
                        onClick={this.handleSelect.bind(this, 'assetSubType', '')}
                        disabled={assetSubType && assetSubType.findIndex(item => (item === 'All' || item === 'Off')) >= 0}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={4}>
                {/* Client */}
                <Form.Item key={'owner'} label={'Select Owner'} style={{ width: '100%' }}>
                  {getFieldDecorator(`owner`, {
                    rules: [{ required: true, message: `Owner is required!` }],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Owner`}
                  >
                    <Select.Option key={'AllOwner'}
                      onClick={this.handleSelect.bind(this, 'owner', 'All')}
                      disabled={ownerFilterType !== 'All' && ownerType && ownerType.length > 0}
                      value={'All'}>All</Select.Option>
                    {(ownerFilterData || []).map(item =>
                      <Select.Option key={item._id}
                        onClick={this.handleSelect.bind(this, 'owner', '')}
                        disabled={ownerType && ownerType.findIndex(item => item === 'All') >= 0}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
            </Row>


            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                Generate Report
              </Button>
            </Form.Item>
            {
              downloadActive ? <Form.Item style={{ marginTop: '14px' }}>
                <CSVLink filename={'report.csv'} className='gx-mb-0 download-button' data={data} headers={headers}>
                  Download Excel
                </CSVLink>
              </Form.Item> : ''
            }
            {
              downloadActive ? <Form.Item>
                <Button type="primary" className="gx-mb-0" onClick={this.downloadPdf.bind(this, cols, data)}>Download
                  Pdf</Button>
              </Form.Item> : ''
            }
          </Form>
          <Table rowClassName={(record => record.key === 'assetTotal' ? 'color-column' : '')}
            pagination={false}
            bordered
            columns={dynamicColumns}
            dataSource={data}
            scroll={{ x: true }} />
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Report);

export default CreateForm;
